import React from 'react';
import InfoToggle from './InfoToggle';

const BistroComboUI = ({ comboComposition }) => {
  if (!comboComposition || comboComposition.length === 0) return null;
  return (
    <InfoToggle title='See Combo Items' defaultOpen={true}>
      <div className='tw-flex tw-flex-col tw-w-full'>
        {comboComposition.map((comboItem, index) => {
          if (!comboItem) return null;
          return (
            <div className='tw-flex tw-flex-col tw-gap-1' key={comboItem.name}>
              <div
                key={comboItem.name}
                className={`tw-flex tw-text-[1.3rem] tw-gap-2 tw-items-center tw-justify-between tw-leading-none tw-p-4 ${
                  index === comboComposition.length - 1
                    ? ''
                    : 'tw-border-x-0 tw-border-[1px] tw-border-solid tw-border-grey-200 tw-border-t-0'
                }`}
              >
                <span className='tw-text-[1.1rem] tw-font-[400] tw-leading-tight tw-flex tw-items-center tw-justify-between tw-gap-2 tw-w-[80%]'>
                  <span
                    className='tw-whitespace-nowrap tw-text-[1.2rem] tw-overflow-hidden tw-text-ellipsis'
                    title={comboItem.name}
                  >
                    {comboItem.name}
                  </span>
                  <span className='tw-text-[1.1rem] tw-text-grey-800 tw-rounded-lg tw-bg-grey-100/50 tw-px-2 tw-py-[2px] tw-border tw-border-solid tw-border-grey-300 tw-whitespace-nowrap tw-leading-none'>
                    {comboItem.unit_of_measurement}
                  </span>
                </span>
                <span className='tw-text-[1.2rem] tw-text-[#1c1c1c] tw-whitespace-nowrap tw-font-medium'>
                  {comboItem.quantity} X ₹{comboItem.price}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </InfoToggle>
  );
};

export default BistroComboUI;
